module.exports = "/images/london-15.jpg";